import type { DataTableFilterField } from '@/components/data-table/types'
import { createSchema, field } from '@/lib/store/schema'
import type { MessagesQueryParams } from '@/hooks/useMessagesQuery'
import type { MessageRecord } from '../types'

export const messagesFilterFields: DataTableFilterField<MessageRecord>[] = [
  {
    label: 'Date',
    value: 'created_at',
    type: 'timerange',
    defaultOpen: true,
  },
  {
    label: 'Direction',
    value: 'direction',
    type: 'checkbox',
    defaultOpen: true,
    compact: true,
    options: [
      { label: 'Incoming', value: 'inbound' },
      { label: 'Outgoing', value: 'outbound' },
    ],
  },
  {
    label: 'Client Name',
    value: 'patient_name',
    type: 'input',
    defaultOpen: true,
  },
  {
    label: 'Phone',
    value: 'phone',
    type: 'input',
    defaultOpen: true,
  },
]

export const messagesSchema = createSchema({
  created_at: field.array(field.timestamp()).delimiter('-').default([]),
  direction: field.array(field.string()).delimiter(',').default([]),
  patient_name: field.string().default(null),
  phone: field.string().default(null),
})

/** Only filter fields affect the query; row selection and sorting metadata do not. */
export function messageFiltersToQuery(
  state: Record<string, unknown> | null | undefined
): MessagesQueryParams {
  const params: MessagesQueryParams = { limit: 50 }
  for (const key of ['patient_name', 'phone'] as const) {
    const value = state?.[key]
    if (typeof value === 'string' && value.trim()) params[key] = value.trim()
  }
  const direction = state?.direction
  if (Array.isArray(direction) && direction.length > 0) {
    params.direction = direction.join(',')
  }
  const range = state?.created_at
  if (Array.isArray(range)) {
    if (range[0] instanceof Date) params.created_after = range[0].toISOString()
    if (range[1] instanceof Date) params.created_before = range[1].toISOString()
  }
  return params
}
